import { RouteObject } from '../common/types';

/**
 * Removes given basePath from the beginning of each route's path
 * (recursively through children also) where applicable.
 *
 * This is necessary when defining react-router routes with `children`
 * and you are using absolute paths (from global paths.ts configuration).
 */
export const onBasePath = (basePath: string, routes: RouteObject[]) =>
  routes.map((route) => {
    const copy = { ...route };

    if (route.path && route.path === basePath) {
      copy.path = '/';
    }

    if (route.path && route.path.startsWith(basePath + '/')) {
      copy.path = route.path.substring(basePath.length);
    }

    if (route.children?.length) {
      copy.children = onBasePath(basePath, route.children);
    }

    return copy;
  });
